<template>
  <a-modal class="modal" :visible="visible" v-bind="$attrs" v-on="$listeners" :closable="false" :maskClosable="false" :footer="null">
    <div class="modal_body">
      <div class="modal_header">
        <svg-icon class="font-17" iconClass=""></svg-icon>
        <slot name="title">
          <span class="modal_title">{{ title }}</span>
        </slot>
        <svg-icon class="font-17 cp" iconClass="close" @click="close"></svg-icon>
      </div>
      <div class="">
        <slot></slot>
      </div>
      <div class="modal_footer" v-if="button">
        <a-button :loading="loading" v-if="type == 'single'" class="single_btn" type="primary" @click="submit">{{ buttonText }}</a-button>
        <div class="btns" v-if="type == 'double'">
          <a-button class="btn_left" @click="close">{{ cancelText }}</a-button>
          <a-button :loading="loading" class="btn_right" type="primary" @click="submit">{{ buttonText }}
            <span v-if="count">({{ num }} S)</span>
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    button: {
      type: Boolean,
      default: true
    },
    count: {
      type: Boolean,
      default: false
    },
    countNum: {
      type: Number,
      default: 10
    },
    type: {
      type: String,
      default: 'single'
    },
    buttonText: {
      type: String,
      default: '确认'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
  },
  data() {
    return {
      closeImg,
      num: 10
    }
  },
  watch: {
    visible(val) {
      if (val && this.count) {
        // 开启倒计时
        this.timer = setInterval(() => {
          if (--this.num < 1) {
            clearInterval(this.timer)
            this.$emit('submit')
          }
        }, 1000)
      } else {
        this.num = 10
        this.timer && (clearInterval(this.timer))
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    submit() {
      // this.$emit('update:visible', false)
      this.$emit('submit')
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-modal-content {
  border-radius: 10px;
}
/deep/.ant-modal-body {
  padding: 0;
}
// .p-22 {
//   padding: 22px;
// }
// .border {
//   border-top: 1px solid #ced3dc;
//   border-bottom: 1px solid #ced3dc;
// }
.modal_body {
  padding: 0 22px 20px;
  color: #303133;
}
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  // padding: 0 22px;
  // margin: -24px;
  // padding: 12px;
  // padding-bottom: 12px;
  // border-bottom: 1px solid #ced3dc;
  .modal_title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
}
// .modal_main {
//   padding: 0 22px;
// }
.modal_footer {
  text-align: center;
  // padding: 12px;
  // margin: 0 -24px -24px;
  // border-top: 1px solid #ced3dc;
  .btns {
    display: flex;
    justify-content: space-around;
    .btn_left {
      border: 1px solid #1564ff;
      color: #1564ff;
    }
    .btn_right {
      background-color: #1564ff;
    }
    .ant-btn {
      width: 177px;
      height: 45px;
      line-height: 45px;
      font-size: 17px;
      border-radius: 22px;
    }
  }
  .single_btn {
    width: 232px;
    height: 40px;
    line-height: 40px;
    // margin-top: 24px;
    // margin-bottom: 11px;
    border-radius: 6px;
    // background-color: #1564FF;
  }
}
</style>
